import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { IQuantityPrice } from '@vp/vp-js-token-engine';

export default class QtyForOnly extends React.Component<IPricePresentationBase<IQuantityPrice>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        classNameWrapper={this.props.classNameWrapper}
        type="qtyForOnly"
        pricingInfo={this.props.pricingInfo}
        tenant={this.props.tenant}
        placeHolderText={this.props.placeHolderText}
        isTile={this.props.isTile}
      />
    );
  }
}
